<div class="wrapper">
  <h1 mat-dialog-title>{{ data.title }}</h1>
  <div mat-dialog-content [innerHTML]="data.description | breakLines">
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="close()">Cerrar</button>
  </div>
</div>